import script from "./EditShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShareModal.vue?vue&type=script&setup=true&lang=js"

import "./EditShareModal.vue?vue&type=style&index=0&id=4fd5588c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd5588c"]])

export default __exports__